import React from "react";
import Stars from "./Stars";
import {useTranslation} from "react-i18next";

const SummaryParts = ({traject, mtb}) => {

    const [t,] = useTranslation('result');

    return (
        <div className="row justify-content-center">
            <div className='col-sm-11'>
                <div className="row sectionPart">
                    <div className="col-sm-3">
                        <h3>{t('MTBSummary_GearSystem')}</h3>
                        {mtb.summary.drive_chain !== null ?
                            <Stars number={Math.round(mtb.summary.drive_chain / 10)}/>
                            : t("Result_NotApplicable")}
                    </div>
                    <div className="col-sm-9">
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_BackDeRailer')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.rear_derailleur_source ? mtb.bike_model.rear_derailleur_source : t("Result_NotApplicable")}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_FrontDeRailer')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.front_derailleur_source ? mtb.bike_model.front_derailleur_source : t("Result_NotApplicable")}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_GearHandles')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.shifters_source ? mtb.bike_model.shifters_source : t("Result_NotApplicable")}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_Cassette')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.cassette_source ? mtb.bike_model.cassette_source : t("Result_NotApplicable")}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_Crankshaft')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.crank_source ? mtb.bike_model.crank_source : t("Result_NotAvailable")}</p>
                            </div>
                        </div>

                    </div>
                    <hr/>
                </div>
                {traject === 'mtb' &&
                <div className="row sectionPart">
                    <div className="col-sm-3">
                        <h3>{t('MTBSummary_Springs')}</h3>
                        {mtb.summary.suspension !== null ?
                            <Stars number={Math.round(mtb.summary.suspension / 10)}/>
                            : t("Result_NotApplicable")}
                    </div>
                    <div className="col-sm-9">
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_FrontFork')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.fork_source ? mtb.bike_model.fork_source : t("Result_NotAvailable")}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_BackDampers')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.shock_source ? mtb.bike_model.shock_source : t("Result_NotApplicable")}</p>
                            </div>
                        </div>

                    </div>

                </div>
                }
                <div className="row sectionPart">
                    <div className="col-sm-3">
                        <h3>{t('MTBSummary_BrakeSystem')}</h3>
                        {mtb.summary.brakes !== null ?
                            <Stars number={Math.round(mtb.summary.brakes / 10)}/>
                            : t("Result_NotApplicable")}
                    </div>
                    <div className="col-sm-9">
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_BrakeSystem')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.brakes_source ? mtb.bike_model.brakes_source : t("Result_NotAvailable")}</p>
                            </div>
                        </div>


                    </div>

                </div>
                {/* Start - CIS 14.06.19 */}
                {traject === 'race' &&
                <div className="row sectionPart">
                    <div className="col-sm-3">
                        <h3>{t('MTBSummary_WheelSet')}</h3>
                        {mtb.summary.score_wheel !== null ?
                            <Stars number={Math.round(mtb.bike_model.score_wheel / 10)}/>
                            : t("Result_NotApplicable")}
                    </div>
                    <div className="col-sm-9">
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_WheelSet')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.wheel_source ? mtb.bike_model.wheel_source : t("Result_NotAvailable")}</p>
                            </div>
                        </div>
                    </div>

                </div>
                }
                {/* End - CIS 14.06.19 */}
                <div className="row sectionPart">
                    <div className="col-sm-3">
                        <h3>{t('MTBSummary_Frame')}</h3>
                        {mtb.summary.frame !== null ?
                            <Stars number={"score score" + Math.round(mtb.summary.frame / 10)}/>
                            : t("Result_NotApplicable")}
                    </div>
                    <div className="col-sm-9">
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_FrameMaterial')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.frame_material_source ? mtb.bike_model.frame_material_source : t("Result_NotAvailable")}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_MaxBurden')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{mtb.bike_model.max_weight_ff === '999' ? t("MTBSummary_NoRestrictions") : mtb.bike_model.max_weight_ff + ' ' + t('MTBSummary_Kilos')}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <p>{t('MTBSummary_FrameGuarantee')}:</p>
                            </div>
                            <div className="col-sm-8">
                                <p>{t('MTBSummary_' + mtb.bike_model.warranty_ff)}</p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
};

export default SummaryParts;